/**
 * 自动生成 router代码【模块名：红人支付对象】
 * 生成日期：2025/11/24 19:38:23
 * 生成路径: src/router/artist_payment.js
 * 生成人：超级管理员
 * 需要在文件 src/router/router.js 引入当前文件
 * import artist_payment from './artist_payment'
 // 路由详情
 const routes = [
 {
 path: '/',
 component: () => import('@/layouts/BasicLayout'),
 name: 'BasicLayout',
 meta: { title: '首页' },
 redirect: '/myNav',
 children: [
 ...
 artist_payment,//红人支付对象
 ]
 */

export default  {
  path: 'artist_payment/list',
  name: 'artist_payment',
  component: () => import('@/pages/artist_payment/ArtistPaymentList'),
  meta: { title: '红人支付对象管理' },
}
